function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  let orderNumber = -1;
  for (let i = 0; i < tablinks.length; i++) {
    if (tablinks[i] == evt.currentTarget) {
      orderNumber = i;
      showViewAll(orderNumber, sectionId);
    }
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

function showViewAll(orderNumber, sectionId) {
  // Remove 'active' class from all buttons
  const buttons = document.querySelectorAll(`.view-collection--${sectionId}`);
  buttons.forEach(button => button.classList.remove('active'));
  
  // Add 'active' class to the clicked button
  buttons[orderNumber].classList.add('active');
}

// show the first tabs by default on load - data-default-open
document.querySelectorAll("[data-default-open]").forEach(el => {
  el.click();
});
window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
});
